import * as ActionType from '../actionTypes';
const dispatchSetLanguage = (data) => ({
  type: ActionType.SET_LANGUAGE,
  payload: data
});

export const setLanguage = (data) => (dispatch) => {
    dispatch(dispatchSetLanguage(data));
}
